import { encoders } from './encoders';

export const logs = {
  encoders,
};
